//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'zepto'
//
export default {
  name: "getImgBase64",
  props: [
    'name',
  ],
  data() {
    return {
      imgSrc: '',
    }
  },
  /*------------------------------------------- 开始运行 -------------------------------------------*/
  created() {
    this.imgSrc = sessionStorage.getItem(this.name);
  },
};



// WEBPACK FOOTER //
// ./src/items/imgBase64.vue